import { ProgressValue } from './progress.value';

export class ProgressValueDto {
    lessonId: string;
    completed: boolean;

    constructor(data: ProgressValue, completed: boolean) {
        this.lessonId = data.lessonId;
        this.completed = completed;
    }
}
